import { ROTULO_PAPEL_PARCEIRO, type PapelParceiro } from '@triade/contracts';

const CHIP = 'rounded-full bg-line-soft px-2 py-0.5 text-caption font-semibold text-ink-body';

/** Papeis atuais do parceiro (Cliente, Fornecedor, ...) como chips. Nada aparece se a lista estiver vazia. */
export function ChipsPapeis({ papeis }: { papeis: PapelParceiro[] }) {
  if (papeis.length === 0) return null;
  return (
    <div role="group" aria-label="Papéis do parceiro" className="flex flex-wrap items-center gap-2" data-testid="papeis-parceiro">
      {papeis.map((p) => (
        <span key={p} className={CHIP}>
          {ROTULO_PAPEL_PARCEIRO[p]}
        </span>
      ))}
    </div>
  );
}
